module.exports = __webpack_public_path__ + "img/bg-2.5843ef2e.jpg";